import { render, staticRenderFns } from "./ContactSupport.vue?vue&type=template&id=108bfb4e&scoped=true&lang=pug&"
import script from "./ContactSupport.vue?vue&type=script&lang=js&"
export * from "./ContactSupport.vue?vue&type=script&lang=js&"
import style0 from "./ContactSupport.vue?vue&type=style&index=0&id=108bfb4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108bfb4e",
  null
  
)

export default component.exports